"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ClockfaceIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "40",
  height: "40",
  viewBox: "0 0 41 41",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-242 -316)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(242 316)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M3.8938,30.8244 C1.9978,27.8134 0.8998,24.2494 0.8998,20.4284 C0.8998,9.6424 9.6428,0.8994 20.4278,0.8994 C31.2128,0.8994 39.9568,9.6424 39.9568,20.4284 C39.9568,31.2144 31.2128,39.9574 20.4278,39.9574 C16.0068,39.9574 11.9288,38.4874 8.6558,36.0114",
          stroke: "#FFF",
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          className: "svg-stroke-secondary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
          stroke: "#4AB05D",
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          points: "11.6711 28.8244 20.8561 20.8454 20.8561 6.4034",
          className: "svg-stroke-primary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M5.2219,33.5773 C5.2219,33.0723 5.6309,32.6623 6.1369,32.6623 C6.6429,32.6623 7.0519,33.0723 7.0519,33.5773 C7.0519,34.0833 6.6429,34.4923 6.1369,34.4923 C5.6309,34.4923 5.2219,34.0833 5.2219,33.5773",
          fill: "#FFF",
          className: "svg-stroke-secondary"
        })]
      })
    })
  })]
});

ClockfaceIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(ClockfaceIcon);

exports.default = _default;